// =============================================================================
// web/shims/react-native-audio-recorder-player.js — WEB shim.
//
// Native audio recording/playback binding. On web, recording voice notes is not
// wired; this shim provides the class surface services/audio.ts expects, with
// every method a graceful no-op that resolves (never throws) so the bundle builds
// and audio simply isn't available on web. Native iOS resolves the real package.
// =============================================================================
class AudioRecorderPlayer {
  async startRecorder() {
    return '';
  }
  async stopRecorder() {
    return '';
  }
  async startPlayer() {
    return '';
  }
  async stopPlayer() {
    return '';
  }
  async pausePlayer() {
    return '';
  }
  async resumePlayer() {
    return '';
  }
  async seekToPlayer() {
    return '';
  }
  async setVolume() {
    return '';
  }
  addRecordBackListener() {}
  removeRecordBackListener() {}
  addPlayBackListener() {}
  removePlayBackListener() {}
  mmssss() {
    return '00:00:00';
  }
  mmss() {
    return '00:00';
  }
}

export default AudioRecorderPlayer;
